import clsx from 'clsx'
import classes from '../Card.module.scss'
// import PropTypes from 'prop-types'

export function CardText({ cardData }) {
    return (
        <div className={clsx(classes.card__text)}>
            {cardData.text}
        </div>
    )
}

// CardText.propTypes = {
//     text: PropTypes.string.isRequired
// }